import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { AlertTriangle, Calendar, Clock, Phone } from 'lucide-react'
import toast from 'react-hot-toast'
import api from '../services/api'

export default function CancelPage() {
  const { token } = useParams()
  const navigate = useNavigate()
  const [appointment, setAppointment] = useState(null)
  const[loading, setLoading] = useState(true)
  const [cancelling, setCancelling] = useState(false)
  const [error, setError] = useState(null)
  const [reason, setReason] = useState('')

  useEffect(() => {
    api.get(`/api/appointments/by-token/${token}`)
      .then(res => setAppointment(res.data))
      .catch(err => setError(err.response?.data?.detail || 'Rendez-vous non trouvé'))
      .finally(() => setLoading(false))
  }, [token])

  const handleCancel = async () => {
    if (!confirm('Êtes-vous sûr de vouloir annuler ce rendez-vous ?')) return

    setCancelling(true)
    try {
      await api.post(`/api/appointments/cancel/${token}`, { reason })
      toast.success('Rendez-vous annulé')
      navigate('/')
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erreur lors de l\'annulation')
    } finally {
      setCancelling(false)
    }
  }

  if (loading) {
    return <div className="flex justify-center items-center py-32"><div className="spinner" /></div>
  }

  if (error) {
    return (
      <div className="max-w-lg mx-auto px-4 py-16 text-center">
        <div className="card">
          <p className="text-red-500 mb-4">{error}</p>
          <a href="/" className="btn btn-primary">Retour à l'accueil</a>
        </div>
      </div>
    )
  }

  if (appointment.status === 'cancelled') {
    return (
      <div className="max-w-lg mx-auto px-4 py-16 text-center">
        <div className="card">
          <p className="text-sage-600 mb-4">Ce rendez-vous a déjà été annulé.</p>
          <a href="/" className="btn btn-primary">Retour à l'accueil</a>
        </div>
      </div>
    )
  }

  return (
    <div className="max-w-2xl mx-auto px-4 py-12">
      <div className="card">
        <h1 className="text-2xl font-serif text-sage-700 mb-6">
          Annuler votre rendez-vous
        </h1>

        {/* Détails du RDV */}
        <div className="bg-sage-50 rounded-xl p-6 mb-6">
          <div className="flex items-center gap-3 mb-3">
            <Calendar className="w-5 h-5 text-sage-400" />
            <span className="font-medium text-sage-700">
              {new Date(appointment.date).toLocaleDateString('fr-FR', {
                weekday: 'long', day: 'numeric', month: 'long'
              })}
            </span>
          </div>
          <div className="flex items-center gap-3">
            <Clock className="w-5 h-5 text-sage-400" />
            <span className="text-sage-700">
              {appointment.start_time?.slice(0, 5)} - {appointment.end_time?.slice(0, 5)}
            </span>
          </div>
        </div>

        {/* AVERTISSEMENT ANNULATION TARDIVE */}
        {appointment.cancellation_warning && (
            <div className="mb-6 bg-red-50 border border-red-200 rounded-xl p-5 flex items-start gap-3 animate-in fade-in zoom-in-95">
                <AlertTriangle className="w-6 h-6 text-red-500 flex-shrink-0" />
                <div>
                    <h4 className="font-bold text-red-800 mb-1">Annulation hors délai</h4>
                    <p className="text-sm text-red-700">{appointment.cancellation_warning}</p>
                </div>
            </div>
        )}

        <div className="mb-6">
            <label className="block text-sm font-medium text-sage-700 mb-2">
            Motif d'annulation (optionnel)
            </label>
            <textarea
            rows={3}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Vous pouvez indiquer la raison de votre annulation..."
            className="w-full"
            />
        </div>

        <div className="flex gap-4">
            <button
            onClick={() => navigate(-1)}
            className="btn btn-secondary flex-1"
            >
            Retour
            </button>
            <button
            onClick={handleCancel}
            disabled={cancelling}
            className="btn btn-danger flex-1"
            >
            {cancelling ? 'Annulation...' : 'Confirmer l\'annulation'}
            </button>
        </div>
      </div>
    </div>
  )
}